import type React from 'react';

import type { Channel, DrillDownBodyProps } from '../types';
import WhatsAppDrillDownBody from './WhatsAppDrillDownBody';

/**
 * Per-channel drill-down registry for channels that render as a single sheet inside the
 * drawer. Meta is intentionally absent — its drill-down is a cascading multi-sheet flow
 * orchestrated directly by `CampaignDetailDrawer` (see MetaCampaignSheet/AdSetSheet/AdSheet).
 */
export const channelDrillDownRegistry: Partial<Record<Channel, React.FC<DrillDownBodyProps>>> = {
  whatsapp: WhatsAppDrillDownBody,
};
